/** TextareaField — multiline input bound to one form key. */
import { Textarea } from "@/components/ui/textarea";
import { Field } from "../_shared";

export default function TextareaField({ field, value, set }) {
  return (
    <Field label={field.label} required={field.required}>
      <Textarea
        data-testid={field.testid}
        rows={field.rows || 3}
        value={value ?? ""}
        onChange={(e) => set(field.key, e.target.value)}
        placeholder={field.placeholder}
      />
    </Field>
  );
}
